import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeCheckRegisterReport extends Layout {
    OfficeCheckRegisterReportDatasource: DataSource;
    checkboxManualPayroll: Checkbox;
    checkboxOfficeChecks: Checkbox;
    excludabletextboxCheckNumbers: ExcludableTextbox;
    excludabletextboxGlAccounts: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    switchSortBy: Switch;
    textboxClearedStatus: Textbox;
    textboxDateRange: Textbox;
    textboxVoidedStatus: Textbox;
}
